import Vue from "vue"
import Vuex from "vuex"
import getters from './getters'
import user from './modules/user'
import settings from './modules/settings'
import themes from './modules/themes'
import feeds from './modules/feeds'
import popup from './modules/popup'
import errors from './modules/errors'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user,
        settings,
        themes,
        feeds,
        popup,
        errors,
    },
    getters
});